import type { HTMLAttributes } from 'react'
import React from 'react'
import classNames from 'classnames'

export type CardProps = {
  htmlTag?: keyof HTMLElementTagNameMap
  radiusSize?: 'normal' | 'large' | 'xlarger' | 'none'
  shadowSize?: 'medium' | 'large' | 'larger' | 'none'
  backgroundShade?: number
  elevated?: boolean
  ref?: React.Ref<HTMLDivElement>
} & HTMLAttributes<HTMLDivElement>

export function Card({
  className,
  children,
  style,
  htmlTag,
  backgroundShade = 100,
  radiusSize = 'large',
  shadowSize = 'medium',
  elevated = true,
  ref,
  ...props
}: CardProps) {
  const _className = classNames(
    'font-family-system border-shade-50-on-dark-mode border-small-on-dark-mode',
    // not using string interpolation on purpose here, to be able to search the class names if need be
    {
      [`radius-${radiusSize}`]: radiusSize !== 'none',
      [`shadow-${shadowSize}`]: shadowSize !== 'none',
      'color-mode-elevated': elevated,
    },
    `background-shade-${backgroundShade}`,
    className
  )

  if (htmlTag) {
    const customTagProps = { ...props, className: _className, style }
    return React.createElement(htmlTag, customTagProps, children)
  }

  return (
    <div {...props} ref={ref} className={_className} style={style}>
      {children}
    </div>
  )
}
